<div class="dev-dashboard-container">
    <div fxLayout="column" fxLayoutGap="16px" class="bg-1">
        <div>
            <form [formGroup]="form" fxLayout="row">
                <div fxLayout="row" fxFlex><span class="txt-h-24-7">{{ 'Energy communities'|i18n }}</span></div>
                <div *ngIf="tenants.length > 1" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">
                        <div class="txt-h-16-4">{{ ('Client filter'|i18n) + ':' }}</div>
                    </div>
                    <div fxFlex app-input-container>
                        <mat-select app-small-select
                                    class="status-filter"
                                    [placeholder]="'Client'|i18n"
                                    [formControl]="formFilter.selectedTenants"
                                    multiple>
                            <mat-option *ngFor="let rootNode of tenants" [value]="rootNode"
                                        [disabled]="!canFilterTenant(rootNode)" class="mat-primary">
                                {{ rootNode.name }}
                            </mat-option>
                        </mat-select>
                    </div>
                    <div fxLayout="row">
                        <button app-small-ghost-button class="app-base-button"
                                (click)="resetFilters()">
                            {{ 'Reset filters'|i18n }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <div fxLayout="row" fxLayoutGap="16px" *ngIf="ecAggregateTotals; else loadingData">
            <div fxLayout="column" fxLayoutAlign="space-around" fxLayoutGap="6px" class="bg-3" fxFlex="15">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayoutGap="20px" fxLayoutAlign="start center">
                        <app-icon name="fal-school" class="txt-h-16-7"></app-icon>
                        <span class="txt-h-16-7">{{ 'Communities'|i18n }}</span>
                    </div>
                    <div>
                        <span class="txt-h-24-7">{{ ecAggregateTotals.energy_communities }}</span>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" fxFlex="48">
                        <span class="txt-h-14-7">{{ 'REC'|i18n }}</span>
                        <span class="txt-h-14-7">{{ ecAggregateTotals.recs }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px" fxFlex="48">
                        <span class="txt-h-14-7">{{ 'CSG'|i18n }}</span>
                        <span class="txt-h-14-7">{{ ecAggregateTotals.csgs }}</span>
                    </div>
                </div>
            </div>
            <!--            <div fxLayout="column" fxLayoutAlign="space-between" fxLayoutGap="16px" class="bg-3" fxFlex="45">-->
            <!--                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" class="txt-h-16-7">-->
            <!--                    <app-icon name="fal-euro-sign"></app-icon>-->
            <!--                    <span>{{'Economic data accounted to this day'|i18n}}</span>-->
            <!--                    <app-icon name="fas-info-circle"-->
            <!--                              [title]="('Economic data billed by GSE'|i18n)">-->
            <!--                    </app-icon>-->
            <!--                </div>-->
            <!--                <div fxLayout="row wrap" fxLayoutGap="80px">-->
            <!--                    <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="16px">-->
            <!--                        <span class="txt-s-14-7">{{'Revenue'|i18n}}:</span>-->
            <!--                        <span class="txt-acc-14-7">{{ecAggregateTotals.total_accounted_revenue|niceValue:'€':2}}</span>-->
            <!--                    </div>-->
            <!--                    <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="16px">-->
            <!--                        <span class="txt-s-14-7">{{'Expenses'|i18n}}:</span>-->
            <!--                        <span class="txt-a-14-7">{{ecAggregateTotals.total_accounted_expenses|niceValue:'€':2}}</span>-->
            <!--                    </div>-->
            <!--                    <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="16px">-->
            <!--                        <span class="txt-s-14-7">{{'Shareable'|i18n}}:</span>-->
            <!--                        <span class="txt-h-14-7">{{ecAggregateTotals.total_accounted_redistributed_incentive|niceValue:'€':2}}</span>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </div>-->
            <div fxLayout="column" fxLayoutAlign="space-around" class="bg-3">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <app-icon name="fal-users" class="txt-h-14-7"></app-icon>
                        <span class="txt-h-16-7">{{ 'Subjects'|i18n }}</span>
                    </div>
                    <div class="txt-h-24-7">{{ ecAggregateTotals.subjects_active + ecAggregateTotals.subjects_inactive }}</div>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="32px">
                    <div fxLayout="row" fxLayoutGap="16px">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                            <div class="txt-h-14-4">{{ 'Active members'|i18n }}</div>
                            <div class="txt-h-14-7">{{ ecAggregateTotals.members_active }}</div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                            <div class="txt-h-14-4">{{ 'Inactive members'|i18n }}</div>
                            <div class="txt-h-14-7">{{ ecAggregateTotals.members_inactive }}</div>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutGap="16px">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                            <div class="txt-h-14-4">{{ 'Active third party producers'|i18n }}</div>
                            <div class="txt-h-14-7">{{ ecAggregateTotals.third_party_producers_active }}</div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                            <div class="txt-h-14-4">{{ 'Inactive third party producers'|i18n }}</div>
                            <div class="txt-h-14-7">{{ ecAggregateTotals.third_party_producers_inactive }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="showPremembershipLink" fxLayout="column" fxLayoutAlign="center" fxFlex="10">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <button class="fix-height" app-ghost-button (click)="onClickGoToPremembership()">
                        {{ 'Candidates'|i18n }}
                        <app-icon class="app-icon-right" name="fal-arrow-right"></app-icon>
                    </button>
                </div>
            </div>
        </div>
        <div fxLayout="column" fxLayoutGap="16px" class="bg-5" *appVar="selectedRangeSubj|async as selectedRange">
            <ng-container *appVar="communities|async as communities">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <div class="txt-h-18-7">{{ 'Communities list'|i18n }}</div>
                    <div fxLayout="row" fxLayoutGap="16px">
                        <button app-ghost-button *ngIf="showRepresentativeBtn"
                                (click)="goToRepresentativesTable()" class="bg-9">
                            <app-icon name="fal-users"></app-icon>
                            {{ 'Representatives'|i18n }}
                        </button>
                        <button app-primary-button
                                (click)="onClickCreateEnergyCommunity()" [disabled]="!canCreateCommunity">
                            <app-icon name="fal-plus-square"></app-icon>
                            {{ 'Create community'|i18n }}
                        </button>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" fxFlex="80">
                        <div app-input-container class="find-community-container" fxFlex="38">
                            <input app-input autocomplete="off"
                                   class="find-community txt-s-16-4"
                                   [(ngModel)]="searchText"
                                   (ngModelChange)="onClickSearchText()"
                                   [spellcheck]="false" [placeholder]="'Search community by name'|i18n">
                            <app-icon *ngIf="searchText && searchText.length>0" name="fal-times" class="right-symbol clear"
                                      (click)="onClickClearSearchText()">
                            </app-icon>
                            <svg *ngIf="!searchText || searchText.length===0" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 512 512"
                                 class="right-symbol mag-glass">
                                <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                                <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z"/>
                            </svg>
                        </div>
                        <div app-input-container class="find-community-container" fxFlex>
                            <input app-input
                                   class="find-community txt-s-16-4"
                                   [matAutocomplete]="membersAutocomplete"
                                   [(ngModel)]="memberSearchText"
                                   (ngModelChange)="onChangeMemberSearchText()"
                                   [spellcheck]="false"
                                   [placeholder]="'Search subject by POD, email, first name, last name or company (min 5 characters)'|i18n">
                            <app-icon *ngIf="memberSearchText && memberSearchText.length>0" name="fal-times" class="right-symbol clear"
                                      (click)="onClickClearMemberSearchText()">
                            </app-icon>
                            <mat-autocomplete #membersAutocomplete="matAutocomplete" (optionSelected)="onOptionSelected($event.option.value)">
                                <mat-option *ngFor="let member of suggestedMembers" [value]="member">
                                    <div fxLayout="row" fxLayoutAlign="space-between center">
                                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                                <div>{{ member.firstName }}</div>
                                                <div>{{ member.lastName }}</div>
                                            </div>
                                            <div>{{ member.pod }}</div>
                                            <div>{{ member.email }}</div>
                                        </div>
                                        <div>{{ member.community }}</div>
                                    </div>
                                </mat-option>
                            </mat-autocomplete>
                            <svg *ngIf="!memberSearchText || memberSearchText.length===0" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 512 512"
                                 class="right-symbol mag-glass">
                                <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                                <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z"/>
                            </svg>
                        </div>
                        <button app-ghost-button *ngIf="selectedMember" (click)="goToMembers()">
                            <div>{{ 'Go to subject'|i18n }}</div>
                            <app-icon class="app-icon-right" name="fal-arrow-right"></app-icon>
                        </button>
                    </div>
                    <form>
                        <mat-checkbox app-checkbox [formControl]="onlyInactiveFormControl" class="pl-16">
                            <span class="txt-h-14-4">{{ 'Only inactive communities'|i18n }}</span>
                        </mat-checkbox>
                    </form>
                </div>
                <div fxLayout="column" class="bg-4" fxLayoutGap="8px">
                    <div fxLayout="row" fxLayoutAlign="space-between">
                        <div fxLayout="column" fxFlex="65">
                            <ng-container *ngIf="communities; else loadingCommunities">
                                <ng-container *ngIf="communities.total > 0">
                                    <table mat-table app-table [dataSource]="communities.communities"
                                           multiTemplateDataRows class="dash-table">
                                        <ng-container matColumnDef="name">
                                            <th mat-header-cell *matHeaderCellDef>
                                                <div fxLayout="row" fxLayoutAlign="start center">
                                                    <div class="txt-h-14-7">{{ 'Name'|i18n }}</div>
                                                    <button *ngIf="getSortDirection(SortCriterion.NAME) === SortDirection.ASC"
                                                            app-icon-button class="sort-button ml-16"
                                                            (click)="onClickSortBy(SortCriterion.NAME, SortDirection.DESC)">
                                                        <app-icon name="fal-sort-alpha-up"></app-icon>
                                                    </button>
                                                    <button *ngIf="getSortDirection(SortCriterion.NAME) === SortDirection.DESC"
                                                            app-icon-button class="sort-button ml-16"
                                                            (click)="onClickSortBy(SortCriterion.NAME, SortDirection.ASC)">
                                                        <app-icon name="fal-sort-alpha-down"></app-icon>
                                                    </button>
                                                </div>
                                            </th>
                                            <td mat-cell *matCellDef="let row">
                                                <div class="txt-h-14-4">{{ row.name ? row.name : '-' }}</div>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="type">
                                            <th mat-header-cell *matHeaderCellDef>
                                                <div fxLayout="row" fxLayoutAlign="start center">
                                                    <div class="txt-h-14-7">{{ 'Type'|i18n }}</div>
                                                    <button app-icon-button class="sort-button ml-16"
                                                            [matMenuTriggerFor]="menu">
                                                        <app-icon name="fal-filter"></app-icon>
                                                    </button>
                                                    <mat-menu #menu="matMenu">
                                                        <mat-checkbox
                                                                app-checkbox
                                                                (click)="$event.stopPropagation()"
                                                                (change)="onClickType()"
                                                                [(ngModel)]="typeFilter.csg"
                                                                [disabled]="!typeFilter.rec"
                                                                class="mat-menu-item">{{ 'CSG'|i18n }}
                                                        </mat-checkbox>
                                                        <br>
                                                        <mat-checkbox
                                                                app-checkbox
                                                                (click)="$event.stopPropagation()"
                                                                (change)="onClickType()"
                                                                [(ngModel)]="typeFilter.rec"
                                                                [disabled]="!typeFilter.csg"
                                                                class="mat-menu-item">{{ 'REC'|i18n }}
                                                        </mat-checkbox>
                                                    </mat-menu>
                                                </div>
                                            </th>
                                            <td mat-cell *matCellDef="let row">
                                                <span class="txt-h-14-7">{{ row.type ? (row.type|i18n) : '-' }}</span>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="activation_date">
                                            <th mat-header-cell *matHeaderCellDef>
                                                <div fxLayout="row" fxLayoutAlign="start center">
                                                    <div class="txt-h-16-7">{{ 'Activation'|i18n }}</div>
                                                    <button *ngIf="getSortDirection(SortCriterion.ACTIVATION_DATE) === SortDirection.ASC"
                                                            app-icon-button class="sort-button ml-16"
                                                            (click)="onClickSortBy(SortCriterion.ACTIVATION_DATE, SortDirection.DESC)">
                                                        <app-icon name="fal-sort-amount-up"></app-icon>
                                                    </button>
                                                    <button *ngIf="getSortDirection(SortCriterion.ACTIVATION_DATE) === SortDirection.DESC"
                                                            app-icon-button class="sort-button ml-16"
                                                            (click)="onClickSortBy(SortCriterion.ACTIVATION_DATE, SortDirection.ASC)">
                                                        <app-icon name="fal-sort-amount-down"></app-icon>
                                                    </button>
                                                </div>
                                            </th>
                                            <td mat-cell *matCellDef="let row">
                                                <span class="txt-s-14-4">
                                                    {{ row.activation_date|i18nDate }}
                                                </span>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="client">
                                            <th mat-header-cell *matHeaderCellDef>
                                                <div fxLayout="row" fxLayoutAlign="start center">
                                                    <div class="txt-h-16-7">{{ 'Client'|i18n }}</div>
                                                </div>
                                            </th>
                                            <td mat-cell *matCellDef="let row">
                                                <span class="txt-s-14-4">
                                                    {{ row.client }}
                                                </span>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="members">
                                            <th mat-header-cell *matHeaderCellDef>
                                                <div class="txt-h-14-7">{{ 'Subjects'|i18n }}</div>
                                            </th>
                                            <td mat-cell *matCellDef="let row">
                                                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px"
                                                     class="txt-h-16-7 bg-row-element members">
                                                    <app-icon name="fal-users" class="txt-h-16-7"></app-icon>
                                                    <span *ngIf="isDefined(row.members); else spinner16">{{ row.members }}</span>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="share">
                                            <th mat-header-cell *matHeaderCellDef>
                                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                    <div class="txt-h-14-7">{{ 'Share'|i18n }}</div>
                                                    <app-icon class="mt-2" name="fas-info-circle"
                                                              [title]="'Related to current year'|i18n">
                                                    </app-icon>
                                                </div>
                                            </th>
                                            <td mat-cell *matCellDef="let row">
                                                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px"
                                                     class="txt-h-16-7 bg-row-element share">
                                                    <app-icon name="fal-city" class="txt-h-16-7"></app-icon>
                                                    <span *ngIf="isDefined(row.share_performance); else spinner16">
                                                        <span *ngIf="!row.active">{{ '--' + ' ' + '%' }}</span>
                                                        <span *ngIf="row.active">{{ (row.share_performance || 0) * 100|niceValue:'%' }}</span>
                                                    </span>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="alarms">
                                            <th mat-header-cell *matHeaderCellDef>
                                                <div fxLayout="row" fxLayoutAlign="start center">
                                                    <div class="txt-h-16-7">{{ 'Alarms'|i18n }}</div>
                                                </div>
                                            </th>
                                            <td mat-cell *matCellDef="let row">
                                                <div *ngIf="isDefined(row.inactive_plants) else spinner16">
                                                    <div class="warning-panel" fxLayout="row" fxLayoutAlign="center center"
                                                         *ngIf="hasAlarms(row)">
                                                        <app-icon class="warning-icon" name="fas-info-circle">
                                                        </app-icon>
                                                    </div>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row *matHeaderRowDef="displayedColumns">
                                        </tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                                            class="app-row row-bg"
                                            (click)="onClickGoToCommunity(row)">
                                        </tr>
                                    </table>
                                </ng-container>
                                <div *ngIf="communities.total === 0" fxLayout="row" fxLayoutAlign="center center"
                                     class="txt-h-16-4 mt-30 mb-20">
                                    <span *ngIf="cleanSearchText === ''">{{ 'No communities found'|i18n }}</span>
                                    <span *ngIf="cleanSearchText !== ''">{{ 'No communities found for: "{0}"'|i18n:cleanSearchText }}</span>
                                </div>
                            </ng-container>
                            <div class="communities-paginator">
                                <mat-paginator #paginator app-paginator
                                               [ngClass]="{'collapsed': !communities || communities.total === 0}"
                                               [length]="communities?.total" [pageSize]="PAGE_SIZE"
                                               [pageSizeOptions]="PAGE_SIZES">
                                </mat-paginator>
                            </div>
                        </div>
                        <ng-container *ngIf="communities">
                            <!--                            <div fxLayout="column" class="bg-8" fxFlex="33" *appVar="locationsSubj|async as locations">-->
                            <div fxLayout="column" class="bg-8" fxFlex="33">
                                <span class="txt-h-20-7 mb-20">{{ 'Localization'|i18n }}</span>
                                <app-google-maps *ngIf="locationsSubj|async"
                                                 [locations]="locationsSubj|async"
                                                 [showMarker]="true">
                                </app-google-maps>
                            </div>
                        </ng-container>
                    </div>

                    <ng-container *ngIf="ecAggregateEnergies; else loadingData">
                        <span class="txt-h-18-7 mt-12">{{ 'Aggregated energy data'|i18n }}</span>
                        <div fxLayout="row" fxLayoutGap="20px" class="mt-18">
                            <ng-container *ngFor="let range of Ranges">
                                <div (click)="onSelectRange(range)"
                                     [ngClass]="{'range': range !== selectedRange , 'range-selected': selectedRange === range}">
                                    {{ range|i18n }}
                                </div>
                            </ng-container>
                        </div>
                        <div fxLayout="row wrap" class="set-gap mt-4">
                            <div fxLayout="row" fxLayoutAlign="space-between center" class="bg-7" fxLayoutGap="15px">
                                <span class="txt-h-14-7">{{ expandedEcAggregatedEnergies.produced_energy|niceValue:'kWh' }}</span>
                                <span class="txt-p-14-4">{{ 'Produced energy'|i18n }}</span>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between center" class="bg-7" fxLayoutGap="15px">
                                <span class="txt-h-14-7">{{ expandedEcAggregatedEnergies.effective_injected_energy|niceValue:'kWh' }}</span>
                                <span class="txt-p-14-4">{{ 'Effective injected energy'|i18n }}</span>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between center" class="bg-7" fxLayoutGap="15px">
                                <span class="txt-h-14-7">{{ expandedEcAggregatedEnergies.consumed_energy|niceValue:'kWh' }}</span>
                                <span class="txt-p-14-4">{{ 'Consumed energy'|i18n }}</span>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between center" class="bg-7" fxLayoutGap="15px">
                                <span class="txt-h-14-7">{{ expandedEcAggregatedEnergies.absorbed_energy|niceValue:'kWh' }}</span>
                                <span class="txt-p-14-4">{{ 'Absorbed energy'|i18n }}</span>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between center" class="bg-7" fxLayoutGap="15px">
                                <span class="txt-h-14-7">{{ expandedEcAggregatedEnergies.self_consumed_energy|niceValue:'kWh' }}</span>
                                <span class="txt-p-14-4">{{ 'Self-consumed energy'|i18n }}</span>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between center" class="bg-7" fxLayoutGap="15px">
                                <span class="txt-h-14-7">{{ expandedEcAggregatedEnergies.self_consumed_energy_ratio|niceValue:'%' }}</span>
                                <span class="txt-p-14-4">{{ 'Self-consumption ratio'|i18n }}</span>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between center" class="bg-7" fxLayoutGap="15px">
                                <span class="txt-h-14-7">{{ expandedEcAggregatedEnergies.shared_energy|niceValue:'kWh' }}</span>
                                <span class="txt-p-14-4">{{ 'Shared energy'|i18n }}</span>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between center" class="bg-7" fxLayoutGap="15px">
                                <span class="txt-h-14-7">{{ expandedEcAggregatedEnergies.shared_energy_ratio|niceValue:'%' }}</span>
                                <span class="txt-p-14-4">{{ 'Shared energy ratio'|i18n }}</span>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between center" class="bg-7" fxLayoutGap="15px">
                                <span class="txt-h-14-7">{{ (expandedEcAggregatedEnergies.saved_co2 / 1000000)|niceValue:'tCO&#8322;' }}</span>
                                <span class="txt-p-14-4">{{ 'Saved {0}'|i18n:'CO&#8322;' }}</span>
                            </div>
                        </div>
                        <div class="plot-bg chart-box mt-8">
                            <ng-container
                                    *ngTemplateOutlet="sharedEnergyChart; context: {data: sharedEnergy}">
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </div>
</div>


<ng-template #sharedEnergyChart let-data="data">
    <div *ngIf="data" fxLayout="column" class="p-16">
        <div *ngIf="!data.length" fxLayout="row" fxLayoutAlign="center">
            {{ 'No data'|i18n }}
        </div>
        <div fxLayout="column" fxLayoutAlign="start stretch">
            <div fxLayout="row" fxLayoutAlign="start" class="ml-20 txt-h-16-7">
                {{ 'Shared energy'|i18n }}
            </div>
            <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="1rem" class="mt-8 mb-8">
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="0.25rem">
                    <span [style]="{'background-color': injectedColor}" class="legend-dot"></span>
                    <span class="txt-p-14-4">{{ 'Effective injected energy'|i18n }}</span>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="0.25rem">
                    <span [style]="{'background-color': absorbedColor}" class="legend-dot"></span>
                    <span class="txt-p-14-4">{{ 'Absorbed energy'|i18n }}</span>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="0.25rem">
                    <span [style]="{'background-color': sharedColor}" class="legend-dot"></span>
                    <span class="txt-p-14-4">{{ 'Shared energy'|i18n }}</span>
                </div>
                <!--                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="0.25rem">-->
                <!--                    <span [style]="{'background-color': sharedColor}" class="legend-dot"></span>-->
                <!--                    <span>{{'Accounted shared energy'|i18n}}</span>-->
                <!--                </div>-->
            </div>
            <div class="shared-energy">
                <app-shared-energy-chart [data]="data"
                                         [padding]="0.25"
                                         [margins]="{left:75, right: -20, top: 10, bottom: 30}"
                                         [xTickSpace]="80"
                                         [yTickSpace]="30"
                                         [yTickFormatter]="'kWh'|yTickFormatter"
                                         [tooltipFormatter]="'kWh'|sharedEnergyTooltipFormatter:true:TIME_DELTA_HOUR"
                                         [xGrid]="true"
                                         [yGrid]="true"
                                         [gridColor]="gridColor"
                                         [tooltipBorderColor]="tooltipBorderColor"
                                         [tooltipBackgroundColor]="tooltipBackgroundColor"
                                         [selectionLineColor]="selectionLineColor"
                                         [resizeTrigger]="contentResize"
                                         [injectionColor]="injectedColor"
                                         [absorptionColor]="absorbedColor"
                                         [sharedColor]="sharedColor">
                </app-shared-energy-chart>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #loadingCommunities>
    <div fxLayout="row" fxLayoutAlign="center center" class="mt-24 mb-16">
        <mat-spinner app-spinner diameter="20"></mat-spinner>
        <span class="pl-8">{{ 'Loading communities'|i18n }}...</span>
    </div>
</ng-template>

<ng-template #loadingData>
    <div fxLayout="row" fxLayoutAlign="center center" class="mt-24 mb-16">
        <mat-spinner app-spinner diameter="20"></mat-spinner>
        <span class="pl-8">{{ 'Loading data'|i18n }}...</span>
    </div>
</ng-template>

<ng-template #loadingMeasures>
    <div fxLayout="row" fxLayoutAlign="center center" class="mt-24 mb-16">
        <mat-spinner app-spinner diameter="20"></mat-spinner>
        <span class="pl-8">{{ 'Loading data'|i18n }}...</span>
    </div>
</ng-template>

<ng-template #createCommunity let-data let-close="close">
    <div class="create-community">
        <div fxLayout="column" fxLayoutGap="0.5rem" style="height: fit-content">
            <app-ec-creator
                    (valid)="data.valid = $event"
                    (created)="onCreateCommunity($event, close)">
            </app-ec-creator>
        </div>
    </div>
</ng-template>

<ng-template #spinner16>
    <mat-spinner app-spinner diameter="16"></mat-spinner>
</ng-template>
